import { useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 rounded-md border border-background-300/60 bg-background-50 px-4 py-3 text-left text-sm text-foreground-900 transition hover:border-background-300 cursor-pointer"
      >
        <span className="flex items-center gap-2">
          <i className="ri-apps-2-line text-base text-primary-600"></i>
          <span>{t("dropdown.placeholder")}</span>
        </span>
        <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-20" onClick={() => setOpen(false)}></div>
          <div className="absolute left-0 right-0 z-30 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1">
            {categories.map((cat) => (
              <a
                key={cat.key}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setOpen(false)}
                className="flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-foreground-700 transition hover:bg-background-100 hover:text-foreground-950 cursor-pointer"
              >
                <span>{t(cat.i18nKey)}</span>
                <i className="ri-arrow-right-up-line text-foreground-400"></i>
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  );
}